import {
    FETCH_PROJECT,
    PATCH_PROJECT,
    LOADING_DETAILS,
    DELETE_PROJECT,
    CLEAR_PROJECT,
    POST_PROJECT,
    POST_PROJECT_FAIL,
    SET_FAIL_MESSAGE_PROJECT
} from "../actionsType";

const initialState = {
    id: 0,
    name: "",
    referenceCode: "",
    comment: "",
    isConfidential: false,
    startDate: "",
    endDate: "",
    lastUpdate: "",
    pilot: [],
    copilot: [],
    estimatedInvestmentBudget: 0,
    estimatedExploitationBudget: 0,
    realInvestmentBudget: 0,
    realExploitationBudget: 0,
    estimatedTimeSpent: 0,
    realTimeSpent: 0,
    success: "",
    difficulties: "",
    advancement: "",
    deadline: "",
    creationDate: "",
    weather: "",
    contributions: [],
    threatCreated: "",
    threatNotCreated: "",
    tags: [],
    objectives: [],
    swot: [],
    members: [],
    actions: [],
    stake: {},
    links: [],
    actionAdvancementAVG: 0,
    axisSponsor:{},
    status: 0,
    message: "",
    isLoading: false,
    nextReview: "",
}

const projectReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DETAILS:
            return {
                ...state,
                isLoading: true,
            }
        case FETCH_PROJECT:
            return {
                ...state,
                id: action.payload.id,
                name: action.payload.name,
                referenceCode: action.payload.referenceCode,
                comment: action.payload.comment,
                links:action.payload.links,
                isConfidential: action.payload.isConfidential,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                lastUpdate: action.payload.lastUpdate,
                pilot: action.payload.pilot,
                copilot: action.payload.coPilot,
                estimatedInvestmentBudget: action.payload.estimatedInvestmentBudget,
                estimatedExploitationBudget: action.payload.estimatedExploitationBudget,
                realInvestmentBudget: action.payload.realInvestmentBudget,
                realExploitationBudget:action.payload.realExploitationBudget,
                estimatedTimeSpent: action.payload.estimatedTimeSpent,
                realTimeSpent: action.payload.realTimeSpent,
                success: action.payload.success,
                difficulties: action.payload.difficulties,
                advancement: action.payload.advancement,
                tags: action.payload.tags,
                deadline: action.payload.deadline,
                creationDate: action.payload.creationDate,
                weather: action.payload.weather,
                contributions: action.payload.contributions,
                threatCreated: action.payload.threatCreated,
                threatNotCreated: action.payload.threatNotCreated,
                objectives: action.payload.objectives,
                swot: action.payload.swot,
                members: action.payload.members,
                actions: action.payload.actions,
                stake: action.payload.stake,
                axisName: action.payload.axisName,
                actionAdvancementAVG: action.payload.actionAdvancementAVG,
                isTimeSpentOptional: action.payload.isTimeSpentOptional,
                isBudgetOptional: action.payload.isBudgetOptional,
                axisSponsor: action.payload.axisSponsor,
                status: action.payload.status,
                message: action.payload.message,
                isLoading: false,
                nextReview: action.payload.nextReview,
            }
        case PATCH_PROJECT:
            return {
                ...state,
                id: action.payload.id,
                name: action.payload.name,
                referenceCode: action.payload.referenceCode,
                links:action.payload.links,
                comment: action.payload.comment,
                isConfidential: action.payload.isConfidential,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                lastUpdate: action.payload.lastUpdate,
                pilot: action.payload.pilot,
                tags: action.payload.tags,
                copilot: action.payload.coPilot,
                estimatedInvestmentBudget: action.payload.estimatedInvestmentBudget,
                estimatedExploitationBudget: action.payload.estimatedExploitationBudget,
                realInvestmentBudget: action.realInvestmentBudget,
                realExploitationBudget:action.realExploitationBudget,
                estimatedTimeSpent: action.payload.estimatedTimeSpent,
                realTimeSpent: action.payload.realTimeSpent,
                success: action.payload.success,
                difficulties: action.payload.difficulties,
                advancement: action.payload.advancement,
                deadline: action.payload.deadline,
                creationDate: action.payload.creationDate,
                weather: action.payload.weather,
                contributions: action.payload.contributions,
                threatCreated: action.payload.threatCreated,
                threatNotCreated: action.payload.threatNotCreated,
                objectives: action.payload.objectives,
                swot: action.payload.swots,
                members: action.payload.members,
                actions: action.payload.actions,
                stake: action.payload.stake,
                axisName: action.payload.axisName,
                isTimeSpentOptional: action.payload.isTimeSpentOptional,
                isBudgetOptional: action.payload.isBudgetOptional,
                axisSponsor: action.payload.axisSponsor,
                status: action.payload.status,
                message: action.payload.message,
                nextReview: action.payload.nextReview,
            }
        case DELETE_PROJECT:
            return {
                ...state,
                status: action.payload.status,
                message: action.payload.message
            }
        case POST_PROJECT :
            return {
                ...state,
                status: action.payload.status,
                message: action.payload.message
            }
        case POST_PROJECT_FAIL:
            return {
                ...state,
                status: action.payload.status,
                message: action.payload.message
            }
        case SET_FAIL_MESSAGE_PROJECT :
            return {
                ...state,
                status: action.payload.status,
                message: action.payload.message
            }
        case CLEAR_PROJECT:
            return initialState

        default:
            return {
                ...state
            }
    }
}

export default projectReducer;

